import { useContext, useState } from "react";
import { Button } from "@headlessui/react";

import BaseMenuItem from "./BaseMenuItem";
import { ShopifyObservedImage } from "../../../components/ShopifyObservedImage";
import { Product } from "../../ShopifyTypes";
import { CollectionMenuItem as CollectionMenuItemType } from "../../header-menu/HeaderMenuTypes";
import { HeaderMenuContext } from "../../header-menu/HeaderMenuContext";

interface CollectionMenuItemProps {
  item: CollectionMenuItemType;
  itemIndex: number;
}

export default function CollectionMenuItem({
  item: { buttonText, buttonCollectionHandle, ...baseMenuItem },
  itemIndex,
}: CollectionMenuItemProps) {
  const { headerCollections } = useContext(HeaderMenuContext);
  const { collection: buttonCollection } = headerCollections.find(
    ({ collection: { handle } }) => handle === buttonCollectionHandle
  )!;

  return (
    <BaseMenuItem
      {...baseMenuItem}
      itemIndex={itemIndex}
      subMenuContent={
        <div className="xflex xflex-col xgap-8 xitems-start">
          <CollectionSubMenu collectionHandle={buttonCollectionHandle} />
          <Button
            className="xbtn xbtn-primary xbtn-lg xtext-2xl xw-3/5"
            onClick={() => {
              const url = `/collections/${buttonCollection.handle}`;
              window.location.href = url;
            }}
          >
            {buttonText}
          </Button>
        </div>
      }
    />
  );
}

interface CollectionSubMenuProps {
  collectionHandle: string;
}

function CollectionSubMenu({ collectionHandle }: CollectionSubMenuProps) {
  const { headerCollections } = useContext(HeaderMenuContext);

  const { products } = headerCollections.find(
    ({ collection: { handle } }) => handle === collectionHandle
  )!;

  return (
    <div
      className="
    xgrid xgrid-flow-row xgrid-cols-3
    xgap-6"
    >
      {products.map((product) => (
        <CollectionSubMenuCard
          key={`${collectionHandle}-${product.handle}`}
          product={product}
        />
      ))}
    </div>
  );
}

interface CollectionSubMenuCardProps {
  product: Product;
}

function CollectionSubMenuCard({
  product: { featured_image, title, ...product },
}: CollectionSubMenuCardProps) {
  return (
    <div
      className="
        xflex xflex-col
        xgap-4 xitems-center
        xcursor-pointer
      "
      onClick={(e) => {
        const url = `/products/${product.handle}`;

        e.preventDefault();
        window.location.href = url;
      }}
    >
      <ShopifyObservedImage
        className="
          xobject-cover
          xaspect-square
          xrounded-3xl xshadow-lg
        "
        src={featured_image}
        fallbackWidth={320}
        fallbackHeight={320}
        shopify={{ crop: "center" }}
        loading="lazy"
        alt="green-logo"
        width={320}
        height={320}
      />
      <h3
        className="
          xfont-grotesque
          xtext-3xl xfont-semibold
          xcolor-extra-dark-green
          xtext-center
        "
      >
        {title}
      </h3>
    </div>
  );
}
